import CoinsHistoryList from "../../components/coinsHistory/CoinsHistoryList";
import NavLinksAdmin from "../../components/navlinksAdmin/NavLinksAdmin";

const AdminCoinsHistory = () => {
  return (
    <div className="inside-page-container-blk">
      <div className="admin-page-main-container">
        <NavLinksAdmin />
        <div>
          <CoinsHistoryList />
        </div>
      </div>
    </div>
  );
};

export default AdminCoinsHistory;
